import React from 'react';

export const Loader = () => (
    <ul className="loader loader--v2">
        <li className="loader__ball"></li>
        <li className="loader__ball"></li>
        <li className="loader__ball"></li>
    </ul>
);
